import { TItemDescriptions } from 'factions/factionTypes'
import meta_rule_sources from 'meta/rule_sources'
import {
  BATTLESHOCK_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  DURING_SETUP,
  END_OF_ANY_PHASE,
  END_OF_TURN,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SHOOTING_PHASE,
  START_OF_ROUND,
} from 'types/phases'

const Flavors = {
  'Warhost of Duality': {
    effects: [
      {
        name: `Strike as One - Passive`,
        desc: `Effect: When players are alternating picking units to use a Fight ability, when it is your turn to pick a unit, you can pick 2 friendly Lumineth Realm-Lords units instead of 1. Resolve the second Fight ability immediately after the first.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Scinari Council': {
    effects: [
      {
        name: `Arcane Focus - Passive`,
        desc: `Effect: Spell abilities from the Lore of Hysh or the Lore of the Awakened Realms used by friendly Lumineth Realm-Lords WizardS have the UNLIMITED keyword. However, you cannot pick the same unit to be the target of the same Spell ability in the same turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Aelementor Guardians': {
    effects: [
      {
        name: `Ancient Spirits - Once Per Turn`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Monster to be the target.
        Effect: For the rest of the turn, ignore the first damage point that would be allocated to each visible friendly Lumineth Realm-Lords unit in each phase while it is wholly within 12" of the target.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Pilgrims of Haixiah': {
    effects: [
      {
        name: `Trick of the Light - Passive`,
        desc: `Effect: Friendly Lumineth Realm-Lords units can use the 'Power Through' command even if they have not charged this turn.`,
        when: [END_OF_TURN],
      },
    ],
  },
  'Aelementiri Conclave (AoR)': {
    effects: [
      {
        name: `World Runes - Once Per Battle`,
        desc: `Effect: Add 1 Alaithi, Rune of the Mountain to your library for each friendly Alarith unit on the battlefield.
        Add 1 Oreali, Rune of the Wind to your library for each friendly HURAKAN unit on the battlefield.
        Add 1 Ydriliqi, Rune of the River to your library for each friendly YDRILAN unit on the battlefield.
        You can have a maximum of 6 of each type of rune in your library.`,
        when: [DURING_SETUP],
      },
      {
        name: `Depict Rune - Once Per Battle Round`,
        desc: `Declare: You must use this ability.
        Effect: Remove all runes from your battle scripture. Then, pick any number of runes to remove from your library and depict them on your battle scripture. Runes removed from your library in this way are removed for the rest of the battle.`,
        when: [START_OF_ROUND],
      },
      {
        name: `Entreat Spirit - Once Per Turn`,
        desc: `Declare: You can use this ability if you have 3 or more runes in your library. Pick a friendly non-Unique Monster unit that has been destroyed to be the target.
        Effect: Remove any 3 runes from your library. Then, set up a replacement unit identical to the target wholly within 6" of a terrain feature and more than 9" from all enemy units. Allocate 6 damage points to the replacement unit (ward rolls cannot be made for those damage points).`,
        when: [MOVEMENT_PHASE],
      },
      {
        name: `The Realms Fight Back - Once Per Turn`,
        desc: `Declare: Pick a terrain feature. Then, pick an enemy unit within 6" of that terrain feature to be the target.
        Effect: Roll a D3 and apply the corresponding effect for the rest of the turn.
        Eruption of Earth: Inflict 3 mortal damage on the target.
        Howling Winds: Subtract 5 from the target's control score.
        Flash Flood: The target has Strike-Last.`,
        when: [COMBAT_PHASE],
      },
    ],
  },
  'Vanari Paragons (AoR)': {
    effects: [
      {
        name: `Rewards of Valor - Once Per Battle`,
        desc: `Declare: Pick a friendly non-Unique Vanari Hero that does not have an artefact of power to be the target.
        Effect: Give the target 1 artefact of power from the 'Vanari Paragons' Army of Renown rules.`,
        when: [DURING_SETUP],
      },
      {
        name: `Labour of Control - Once Per Battle`,
        desc: `Declare: You can only use this ability if there is at least 1 different friendly unit within 6" of each battlefield edge.
        Effect: Add 1 to the number of labours you have completed. For the rest of the battle, add 2" to the Move characteristic of friendly Lumineth Realm-Lords units.`,
        when: [END_OF_TURN],
      },
      {
        name: `Labour of Might - Once Per Battle`,
        desc: `Declare: You can only use this ability if 3 or more enemy units have been destroyed this battle.
        Effect: Add 1 to the number of labours you have completed. For the rest of the battle, add 1 to wound rolls for combat attacks made by friendly Lumineth Realm-Lords units.`,
        when: [END_OF_TURN],
      },
      {
        name: `Labour of Precision - Once Per Battle`,
        desc: `Declare: You can only use this ability if there are no enemy units with an artefact of power on the battlefield.
        Effect: Add 1 to the number of labours you have completed. For the rest of the battle, add 10 to the control scores of friendly Lumineth Realm-Lords units.`,
        when: [END_OF_TURN],
      },
      {
        name: `Blessing of Tyrion - Once Per Battle`,
        desc: `Declare: You can only use this ability if you have completed 3 labours.
        Effect: For the rest of the battle, friendly Lumineth Realm-Lords units have Ward (5+).`,
        when: [END_OF_TURN],
      },
    ],
  },
  /* Ymetrica: {
    effects: [
      {
        name: `Mountain Realm`,
        desc: `The Enduring as Rock ability of friendly Ymetrica Alarith units worsens the Rend characteristic of attacks that target those units by 2 instead of 1, to a minimum of 0.`,
        when: [COMBAT_PHASE, SHOOTING_PHASE],
        rule_sources: [meta_rule_sources.BATTLESCROLL_ANDTOR_SEPTEMBER_2023],
      },
    ],
  },
  Syar: {
    effects: [
      {
        name: `Gleaming Brightness`,
        desc: `Friendly Syar units start the battle with 2 aetherquartz reserves instead of 1.`,
        when: [DURING_GAME],
      },
    ],
  },
  Iliatha: {
    effects: [
      {
        name: `Unity of Purpose`,
        desc: `Once per turn, you can say that 2 friendly Iliatha Vanari units will use their aetherquartz reserves to use an aetherquartz reserve ability in the same phase instead of only 1.`,
        when: [DURING_GAME],
      },
    ],
  },
  Zaitrec: {
    effects: [
      {
        name: `Lambent Mystics`,
        desc: `Add 1 to casting, dispelling or unbinding rolls for friendly Zaitrec Wizards.`,
        when: [HERO_PHASE],
      },
    ],
  }, */
  /* Alumnia: {
    effects: [
      {
        name: `Claim the field`,
        desc: `If the base of each model in a friendly Alumnia Vanari unit is touching the bases of 2 or more other models in the same unit, each model in that unit that is within 6" of an objective counts as 2 models for the purposes of contesting that objective.`,
        when: [BATTLESHOCK_PHASE],
      },
    ],
  },
  Helon: {
    effects: [
      {
        name: `Gale of Killing Shafts`,
        desc: `In your shooting phase, when you pick a friendly Helon unit to shoot, you can say that it will unleash a gale of killing shafts. If you do so, in that phase, you can add 1 to hit rolls and wound rolls for that unit's missile weapons, but that unit can only target enemy units within 6" of it.`,
        when: [SHOOTING_PHASE],
        rule_sources: [meta_rule_sources.BATTLESCROLL_ANDTOR_SEPTEMBER_2023],
      },
    ],
  }, */
} satisfies TItemDescriptions

export default Flavors
